import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import css from './styles.module.scss';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { getUserProfileData } from '~/features/dashboard/store/selectors';
import { getUserProfile } from '~/features/dashboard/store/actions.thunks';
import classNames from 'classnames';
import { createStyles, Grid, IconButton, ListItem, ListItemText, makeStyles, Popover, Theme, Typography } from '@material-ui/core';
import List from '@material-ui/core/List';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { axiosInstance } from '~/api/config/axios.config';
import { UserProfile } from '~/models/profile/UserProfile.dto';
import Button from '@material-ui/core/Button';
import { Loader } from '~/common/loader';
import Autocomplete, { AutocompleteRenderInputParams } from '@material-ui/lab/Autocomplete/Autocomplete';
import { TextFieldOutlined } from '~/common/text-field-outlined';


interface ContentProps {
    user: any;
    tab: number;
    changeData: any;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        popover: {
            pointerEvents: 'none',
        },
        popoverContent: {
            pointerEvents: 'auto',
        },
        root: {
            width: '100%',
            maxWidth: 360,
            backgroundColor: theme.palette.background.paper,
        },
        large: {
            width: theme.spacing(20),
            height: theme.spacing(20),
            margin: 'auto',
        },
    })
);

export const ProfileLocalization: React.FC<ContentProps> = ({ user, tab, changeData }) => {

    const classes = useStyles();
    const dispatch = useThunkDispatch();

    const [isEditForm, setIsEditForm] = useState(false);
    const [userProfile, setUserProfile] = useState(new UserProfile());
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const userProfileResponse = useSelector(getUserProfileData);
    useMemo(() => {
        if(userProfileResponse){
            if(!userProfileResponse.dateFormat){
                userProfileResponse.dateFormat = 'ddMYYY'
            }
            if(!userProfileResponse.timeFormat){
                userProfileResponse.timeFormat = 'hh:mm:ss'
            }
            if(!userProfileResponse.timeZone){
                userProfileResponse.timeZone = '+4.00'
            }
            setUserProfile(userProfileResponse);
        }
        return userProfileResponse;
    }, [userProfileResponse]);

    useEffect(() => {
        dispatch(getUserProfile());
    }, [dispatch]);

    const dateFormats: any = [
        'DD/MM/YYYY',
        'MM/DD/YYYY',
        'DD/MM/YY',
        'MM/DD/YY',
        'DD MMM YYYY',
        'DD-MM-YYYY',
        'YYYY-MM-DD',
    ];

    const timeFormats: any = [
        'HH:MM:SS',
        'HH:MM',
    ];

    const timeZones: any = [
        '+12.00',
        '+11.00',
        '+10.00',
        '+9.00',
        '+8.00',
        '+7.00',
        '+6.00',
        '+5.00',
        '+4.00',
        '+3.00',
        '+2.00',
        '+1.00',
        '0',
        '-1.00',
        '-2.00',
        '-3.00',
        '-4.00',
        '-5.00',
        '-6.00',
        '-7.00',
        '-8.00',
        '-9.00',
        '-10.00',
        '-11.00',
        '-12.00',
    ];

    // const elementFocus = (ref: any) => {
    //     if (ref) {
    //         ref.current.focus();
    //     }
    // };

    const updateData = (name: string, value: any) => {
        if (name) {
            setUserProfile({ ...userProfile, [name]: value });
        }
    };

    const open = Boolean(anchorEl);
    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const editContactForm = () => {
        setIsEditForm(true);
    };

    const submitForm = () => {
        setIsEditForm(false);
        setIsLoading(true)
        let data = userProfile;
        axiosInstance
            .put('catalogue/projectCreator/userProfile/save', {
                ...data,
            })
            .then((res) => {
                setUserProfile(res.data);
                setIsLoading(false);
                dispatch(getUserProfile());
            });
    };

    const cancelForm = () => {
        setIsLoading(true);
        dispatch(getUserProfile());
        setIsEditForm(false);
        setIsLoading(false)
    }

    return (
        <div className={css.module}>

            {
                isLoading ? (
                    <Loader className={css.loader}/>
                ) : (

                    <>

                        <Grid container className={css.avatarContainer}>

                            {
                                isEditForm ? (

                                    <>

                                        <Grid item xs={12}>
                                            <Grid container>
                                                <Grid item xs>
                                                    <Autocomplete
                                                        options={dateFormats}
                                                        fullWidth
                                                        value={userProfile?.dateFormat}
                                                        renderInput={(p: AutocompleteRenderInputParams) => (
                                                            <TextFieldOutlined {...p} label="Date Format" />
                                                        )}
                                                        onChange={(_, data) => updateData('dateFormat', data)}
                                                        className={css.inputCurrency}
                                                    />
                                                </Grid>

                                                <Grid item xs>
                                                    <Autocomplete
                                                        options={timeFormats}
                                                        fullWidth
                                                        value={userProfile?.timeFormat}
                                                        renderInput={(p: AutocompleteRenderInputParams) => (
                                                            <TextFieldOutlined {...p} label="Time Format" />
                                                        )}
                                                        onChange={(_, data) => updateData('timeFormat', data)}
                                                        className={css.inputSelect}
                                                    />
                                                </Grid>

                                                <Grid item xs>
                                                    <Autocomplete
                                                        options={timeZones}
                                                        fullWidth
                                                        value={userProfile?.timeZone}
                                                        renderInput={(p: AutocompleteRenderInputParams) => (
                                                            <TextFieldOutlined {...p} label="Time Zone" />
                                                        )}
                                                        onChange={(_, data) => updateData('timeZone', data)}
                                                        className={css.inputSelect}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Button variant="contained" className={css.submitBtn} onClick={submitForm}>Submit</Button>
                                            <Button variant="contained" className={css.cancelBtn} onClick={cancelForm}>Cancel</Button>
                                        </Grid>
                                    </>

                                ) : (

                                    <>

                                        <Grid item xs={12} className={css.marginTopContainer}>
                                            <Grid container>
                                                <Grid item xs>
                                                    <Typography className={classNames(css.bold, css.infoTitle)}>Date Format</Typography>
                                                    <Typography className={classNames(css.infoContent)}>{userProfile?.dateFormat}</Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Typography className={classNames(css.bold, css.infoTitle)}>Time Format</Typography>
                                                    <Typography className={classNames(css.infoContent)}>{userProfile?.timeFormat}</Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Typography className={classNames(css.bold, css.infoTitle)}>Time Zone</Typography>
                                                    <Typography className={classNames(css.infoContent)}>{userProfile?.timeZone}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>

                                )
                            }

                        </Grid>


                        <IconButton
                            className={classNames(css.editIcon)}
                            aria-label="add to favorites"
                            aria-owns={open ? 'mouse-over-popover' : undefined}
                            aria-haspopup="true"
                            onMouseEnter={handlePopoverOpen}
                        >
                            <MoreVertIcon />
                        </IconButton>

                        <Popover
                            id="mouse-over-popover"
                            className={classes.popover}
                            classes={{
                                paper: classes.popoverContent,
                            }}
                            open={open}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                            PaperProps={{ onMouseLeave: handlePopoverClose }}
                        >
                            <List component="nav" className={classes.root} aria-label="contacts">
                                <ListItem button onClick={editContactForm}>
                                    <ListItemText primary="Edit" />
                                </ListItem>
                            </List>
                        </Popover>
                    </>

                )
            }

        </div>
    );
};
